/**
 * useAdminItems
 *
 * Returns the static, ordered list of admin tool rows rendered inside the
 * AdminSheet.
 *
 * Flutter source: lib/presentation/screens/admin/admin_screen.dart (the
 * `_items` list, lines 34-59). Order mirrors the Flutter ordinal order:
 * identityVerification, latestUsers, feedback, transactions. The web
 * `iconPath`s map 1:1 from Flutter's `assets/images/*.png` to the public
 * `/assets/images/*.png` files.
 */

import { useLocale } from '@/presentation/contexts/LocaleContext';
import type { AdminItemEntity } from '@/domain/entities/admin/adminItemEntity';
import { AdminItemType } from '@/domain/enums/admin/adminItemType';

export const useAdminItems = (): AdminItemEntity[] => {
  const { l10n } = useLocale();

  return [
    {
      type: AdminItemType.IDENTITY_VERIFICATION,
      title: l10n.admin.identityVerifications,
      description: l10n.admin.identityVerificationsDescription,
      iconPath: '/assets/images/verify.png',
    },
    {
      type: AdminItemType.LATEST_USERS,
      title: l10n.admin.latestUsers,
      description: l10n.admin.latestUsersDescription,
      iconPath: '/assets/images/avatar.png',
    },
    {
      type: AdminItemType.FEEDBACK,
      title: l10n.admin.feedback,
      description: l10n.admin.feedbackDescription,
      iconPath: '/assets/images/feedback.png',
    },
    {
      type: AdminItemType.TRANSACTIONS,
      title: l10n.admin.transactions,
      description: l10n.admin.transactionsDescription,
      iconPath: '/assets/images/coins.png',
    },
  ];
};
